<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="420"
    height="300"
    id="milestone-deploybutton"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 336.5 237.2"
    role="presentation"
    aria-labelledby="deploybutton"
  >
    <title id="deploybutton">Creation of Deploy Button</title>
    <g id="stacks">
      <g>
        <path class="cls-1" d="M85.7,69l.8.6,19-10.9-1-.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M88.1,70.5l1,.6L108,60.2l-.9-.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M90.6,71.9l1,.5,18.8-10.9-.8-.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M93.2,73.4l.8.5L112.9,63l-.9-.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M95.5,74.9l1,.5,18.8-10.9-.9-.7Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M98,76.2l.9.6,18.9-10.9-.9-.6Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M100.5,77.7a2.3,2.3,0,0,0,1.1.3l18.1-10.4c0-.2-.1-.6-.4-.7Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M84.2,68.1l18.9-10.9-1.1-.3L83.7,67.3C83.7,67.6,84,67.9,84.2,68.1Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-2"
          d="M111.5,9h-25c-.2,0-.4.3-.4.5V61a2.7,2.7,0,0,0,1.7,2.2l7.4,4.3c2.1,1.2,5.3,1.4,7,.3l8.6-4.9A2.4,2.4,0,0,0,112,61V9.5A.5.5,0,0,0,111.5,9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M111.5,9H100V68.5a5.6,5.6,0,0,0,2.3-.6l8.6-4.9a2.1,2.1,0,0,0,1.2-1.8V9.6C112,9.3,111.8,9,111.5,9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M99.3,69.4a9.6,9.6,0,0,1-4.4-1.1L87.4,64a5,5,0,0,1-2-2.1h-.1V9.6a1.2,1.2,0,0,1,1.2-1.2h25a1.2,1.2,0,0,1,1.2,1.2V62h-.1a2.9,2.9,0,0,1-1.5,1.8l-8.5,4.9A8.4,8.4,0,0,1,99.3,69.4ZM86.8,61c0,.6.5,1.1,1.3,1.6l7.5,4.3a6.5,6.5,0,0,0,6.2.2l8.6-4.8c.4-.3.9-.7.9-1.1v-.9h.1V9.7H86.9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-3"
          d="M110.8,11l-8.6,4.9a8.6,8.6,0,0,1-7-.3l-7.4-4.3c-2.1-1.2-2.4-3-.5-4l8.5-4.9a8.2,8.2,0,0,1,7,.2l7.5,4.3C112.4,8.2,112.6,10,110.8,11Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M99.3,17.3a8.5,8.5,0,0,1-4.4-1.1l-7.5-4.3A3.5,3.5,0,0,1,85.3,9a2.8,2.8,0,0,1,1.6-2.4l8.6-4.9c2.1-1.3,5.5-1.1,7.8.2l7.5,4.3a3.5,3.5,0,0,1,2.1,2.9,3.2,3.2,0,0,1-1.6,2.5l-8.6,4.9A6.6,6.6,0,0,1,99.3,17.3ZM98.8,2.4a5.7,5.7,0,0,0-2.7.6L87.5,7.9c-.3.3-.8.6-.8,1.1s.5,1.1,1.3,1.6l7.5,4.3a6.5,6.5,0,0,0,6.2.2l8.6-4.9a1.3,1.3,0,0,0,.8-1.1c0-.5-.4-1.1-1.3-1.6l-7.5-4.2A5.7,5.7,0,0,0,98.8,2.4Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M96.9,16H95.4V68h1.5Z" transform="translate(0 -0.8)" />
        <path class="cls-2" d="M109.7,13.9h-1.3V61.8h1.3Z" transform="translate(0 -0.8)" />
      </g>
      <g>
        <path class="cls-1" d="M97.3,82.4l-.8-.6L77.6,92.7l.9.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M99.8,83.8l-.9-.5L80.1,94.2l.8.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M90,78l-.9-.4L70.3,88.4l.8.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M92.4,79.5l-.8-.5L72.7,89.9l.9.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M95,81l-1-.5L75.2,91.4l.8.5Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M101.7,85.6c0-.2-.1-.6-.3-.7L82.5,95.8a2.5,2.5,0,0,0,1.1.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M85.1,75.2,84,74.9,65.7,85.3a1.2,1.2,0,0,0,.5.7Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M86.7,76.1,67.7,87l1,.5L87.5,76.6Z" transform="translate(0 -0.8)" />
        <path
          class="cls-2"
          d="M94,53.4H69a.6.6,0,0,0-.5.5V79.4a3,3,0,0,0,1.8,2.2l7.4,4.3c2.1,1.2,5.3,1.3,7,.2l8.6-4.9a2.3,2.3,0,0,0,1.2-1.8V53.9C94.6,53.7,94.4,53.4,94,53.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M81.8,87.8a8.5,8.5,0,0,1-4.4-1.1l-7.5-4.3a4.8,4.8,0,0,1-2-2h-.1V54.2A1.2,1.2,0,0,1,69,53H94a1.2,1.2,0,0,1,1.2,1.2V80.5h-.1a3.2,3.2,0,0,1-1.5,1.8l-8.5,4.9A9.7,9.7,0,0,1,81.8,87.8ZM69.4,79.4c0,.6.5,1.1,1.4,1.6l7.4,4.3a6.7,6.7,0,0,0,6.3.2L93,80.6c.4-.2.9-.6.9-1.1v-.8H94V54.2H69.5Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M94,53.6H82.5V87a7.7,7.7,0,0,0,2.3-.6l8.6-4.9a2.2,2.2,0,0,0,1.2-1.9V54.2C94.6,53.7,94.4,53.6,94,53.6Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-3"
          d="M93.4,55.4l-8.6,4.9a8,8,0,0,1-6.9-.2l-7.5-4.3c-2.1-1.3-2.3-3.1-.5-4.1l8.6-4.9a8.4,8.4,0,0,1,6.9.3l7.5,4.3C95,52.6,95.1,54.4,93.4,55.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M81.8,61.8a9.6,9.6,0,0,1-4.4-1.1l-7.5-4.3a3.6,3.6,0,0,1-2.1-3A2.9,2.9,0,0,1,69.4,51L78,46.1a8.6,8.6,0,0,1,7.8.2l7.5,4.3a3.8,3.8,0,0,1,2.1,3A3.2,3.2,0,0,1,93.8,56l-8.6,4.9A6.2,6.2,0,0,1,81.8,61.8Zm-.4-15a7.2,7.2,0,0,0-2.7.6l-8.6,4.9c-.3.3-.8.7-.8,1.1s.5,1.1,1.3,1.6l7.5,4.3a6.8,6.8,0,0,0,6.2.3l8.6-4.9c.4-.3.9-.6.9-1.1s-.5-1.1-1.4-1.6L85,47.7A7.4,7.4,0,0,0,81.4,46.8Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M79.4,60.4H77.9v26h1.5Z" transform="translate(0 -0.8)" />
      </g>
      <g>
        <path class="cls-1" d="M24.2,96l-.8-.5L4.5,106.4l.9.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M26.7,97.5l-.9-.5L7,107.9l.8.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M29.3,99l-.9-.5-19,10.9,1,.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M31.6,100.4l-.9-.6L11.9,110.7l.8.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M34.2,101.9l-.9-.6-19,10.9,1,.6Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M36,103.6c0-.2-.1-.6-.4-.7L16.8,113.8a2,2,0,0,0,1.1.3Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M19.3,93.2a2.1,2.1,0,0,0-1.1-.4L0,103.4a1.2,1.2,0,0,0,.5.7Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M20.9,94.1,2.1,105l.8.6L21.8,94.7Z" transform="translate(0 -0.8)" />
        <path
          class="cls-2"
          d="M28.4,88.7H3.4a.5.5,0,0,0-.5.5v7.7a3,3,0,0,0,1.8,2.2l7.4,4.3c2.1,1.2,5.3,1.3,7,.2l8.6-4.9a2.3,2.3,0,0,0,1.2-1.8V89.2A.5.5,0,0,0,28.4,88.7Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M16.2,105.2a9.6,9.6,0,0,1-4.4-1.1L4.3,99.8a4.5,4.5,0,0,1-2-2.1H2.2V89.3a1.2,1.2,0,0,1,1.2-1.2h25a1.4,1.4,0,0,1,.9.3,1.6,1.6,0,0,1,.3.9v8.6h-.1A3.2,3.2,0,0,1,28,99.7l-8.5,4.9A8.4,8.4,0,0,1,16.2,105.2ZM3.7,96.8c0,.6.5,1.1,1.3,1.5l7.5,4.3c1.8,1.1,4.6,1.3,6.2.3L27.3,98c.4-.3.9-.6.9-1.1V96h.1V89.3H3.8Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M28.4,88.7H16.9v15.6a5.6,5.6,0,0,0,2.3-.6l8.6-4.9A2.3,2.3,0,0,0,29,97V89.3A.7.7,0,0,0,28.4,88.7Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-3"
          d="M27.7,90.6l-8.6,4.9a8.2,8.2,0,0,1-7-.2L4.7,91c-2.1-1.2-2.4-3.1-.5-4l8.5-4.9a8.2,8.2,0,0,1,7,.2l7.5,4.3C29.3,87.7,29.5,89.5,27.7,90.6Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M16.2,97a9.6,9.6,0,0,1-4.4-1.1L4.3,91.6a3.4,3.4,0,0,1-2.1-2.9,3,3,0,0,1,1.6-2.5l8.6-4.9a8.3,8.3,0,0,1,7.8.3l7.5,4.3a3.5,3.5,0,0,1,2.1,2.9,3.4,3.4,0,0,1-1.6,2.5l-8.6,4.8A5.8,5.8,0,0,1,16.2,97Zm-.5-15.1a5.7,5.7,0,0,0-2.7.7L4.4,87.5a1.3,1.3,0,0,0-.8,1.1,2,2,0,0,0,1.3,1.5l7.5,4.3c1.8,1.1,4.6,1.3,6.2.3l8.6-4.9c.3-.3.8-.6.8-1.1s-.5-1.1-1.3-1.6l-7.5-4.3A8.2,8.2,0,0,0,15.7,81.9Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M13.8,95.7H12.2v8.2h1.6Z" transform="translate(0 -0.8)" />
        <path class="cls-2" d="M26.6,93.6H25.3v4h1.3Z" transform="translate(0 -0.8)" />
      </g>
      <g>
        <path class="cls-1" d="M107.3,218.6l-.8-.7L87.6,228.8l.9.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M109.8,219.9l-.9-.5L90.1,230.3l.8.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M112.2,221.4l-.8-.5L92.5,231.8l.9.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M114.8,222.8l-1-.5L95,233.2l.8.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M117.1,224.3l-.8-.6L97.4,234.6l.9.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M119.7,225.8l-1-.6L99.9,236.1l.8.6Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M121.5,227.5a.8.8,0,0,0-.3-.7l-18.9,10.8a1.9,1.9,0,0,0,1.1.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M104.9,217.1a1.7,1.7,0,0,0-1.1-.4L85.6,227.2a.9.9,0,0,0,.5.8Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-2"
          d="M114,212.6H89a.5.5,0,0,0-.5.4v7.8c0,.7.6,1.5,1.7,2.2l7.5,4.2a7.3,7.3,0,0,0,7,.3l8.5-4.9a2.1,2.1,0,0,0,1.2-1.8V213A.4.4,0,0,0,114,212.6Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M101.7,229.1a9.9,9.9,0,0,1-4.4-1.1l-7.5-4.3a4.8,4.8,0,0,1-1.9-2.1h-.1v-8.4a1.2,1.2,0,0,1,1.2-1.3h25a1.2,1.2,0,0,1,.8.4,1.2,1.2,0,0,1,.4.9v8.5h-.1a4,4,0,0,1-1.5,1.9l-8.6,4.9A10.2,10.2,0,0,1,101.7,229.1Zm-12.5-8.3c0,.6.5,1.1,1.4,1.5l7.4,4.3c1.9,1.1,4.7,1.3,6.3.3l8.6-4.9c.3-.3.8-.6.8-1.1V220h.1v-6.7H89.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M114,212.6H102.5v15.6a6.5,6.5,0,0,0,2.3-.6l8.5-4.9a2.2,2.2,0,0,0,1.3-1.8v-7.7Q114.3,212.6,114,212.6Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-3"
          d="M113.2,214.5l-8.5,4.9a8.2,8.2,0,0,1-7-.2l-7.5-4.3c-2.1-1.2-2.3-3.1-.5-4.1l8.6-4.9a8.6,8.6,0,0,1,7,.3l7.4,4.3C114.8,211.6,115.1,213.4,113.2,214.5Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M101.7,220.9a9.9,9.9,0,0,1-4.4-1.1l-7.5-4.3a3.4,3.4,0,0,1-2-2.9,3,3,0,0,1,1.6-2.5l8.5-4.9a8.5,8.5,0,0,1,7.9.3l7.4,4.2a3.6,3.6,0,0,1,2.1,3,2.8,2.8,0,0,1-1.6,2.4l-8.6,4.9A6.4,6.4,0,0,1,101.7,220.9Zm-.5-15.1a7.6,7.6,0,0,0-2.7.6L90,211.3c-.4.3-.9.6-.9,1.1s.5,1.1,1.4,1.6l7.4,4.3a7,7,0,0,0,6.3.3l8.5-4.9c.4-.3.9-.7.9-1.1s-.5-1.1-1.4-1.6l-7.4-4.3A8.3,8.3,0,0,0,101.2,205.8Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M99.3,219.5H97.7v8.2h1.6Z" transform="translate(0 -0.8)" />
        <path class="cls-2" d="M112.1,217.4h-1.2v4.1h1.2Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M88.9,203.5a3.2,3.2,0,0,1,0-6.4,3.2,3.2,0,0,1,3.1,3.2A3.1,3.1,0,0,1,88.9,203.5Zm0-4.7a1.6,1.6,0,0,0-1.6,1.6,1.6,1.6,0,0,0,1.6,1.6,1.6,1.6,0,0,0,1.6-1.6A1.7,1.7,0,0,0,88.9,198.8Z"
          transform="translate(0 -0.8)"
        />
      </g>
      <g>
        <path
          class="cls-1"
          d="M301.2,163l3-1.7-.9-.6-3.4,1.9-15.4,9,.8.6Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M306.7,162.6l-.9-.5L286.9,173l.9.6Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M309.1,164.1l-.9-.5-18.9,10.9.9.5Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M311.6,165.6l-.8-.5-19,10.9,1,.4Z" transform="translate(0 -0.8)" />
        <path class="cls-1" d="M294.2,177.3l.9.6L314,167l-.9-.6Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M301.7,159.8a2.5,2.5,0,0,0-1.1-.4L282.4,170a.9.9,0,0,0,.5.7Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-2"
          d="M310.5,99.2H285.6a.5.5,0,0,0-.5.5v63.4a2.9,2.9,0,0,0,1.7,2.2l7.4,4.3c2.1,1.2,5.3,1.3,7,.2l8.6-4.9a2.1,2.1,0,0,0,1.2-1.8V99.7A.5.5,0,0,0,310.5,99.2Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M298.2,171.4a8.5,8.5,0,0,1-4.4-1.1l-7.5-4.3a4.8,4.8,0,0,1-2-2h-.1V99.8a1.2,1.2,0,0,1,1.2-1.2h25a1.1,1.1,0,0,1,.9.4,1.3,1.3,0,0,1,.3.8V164h-.1a3.2,3.2,0,0,1-1.5,1.8l-8.5,4.9A6.5,6.5,0,0,1,298.2,171.4ZM285.8,163c0,.6.5,1.1,1.3,1.6l7.5,4.3a6.7,6.7,0,0,0,6.3.2l8.5-4.9c.4-.2.9-.6.9-1.1v-.9h.1V99.8H285.9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M310.5,99.2H299v71.4a12.8,12.8,0,0,0,2.3-.6l8.6-4.9a2.2,2.2,0,0,0,1.2-1.9V99.7C311,99.5,310.8,99.2,310.5,99.2Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-3"
          d="M309.8,101.2l-8.6,4.9c-1.8,1-4.9.8-7-.3l-7.4-4.3c-2.1-1.2-2.3-3-.5-4l8.6-4.9a8,8,0,0,1,6.9.3l7.5,4.2C311.4,98.2,311.6,100.1,309.8,101.2Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M298.2,107.5a8.5,8.5,0,0,1-4.4-1.1l-7.5-4.2a3.6,3.6,0,0,1-2.1-3,2.8,2.8,0,0,1,1.6-2.4l8.6-4.9c2-1.3,5.5-1.1,7.8.2l7.5,4.3a3.4,3.4,0,0,1,2,2.9,3.1,3.1,0,0,1-1.5,2.5l-8.6,4.9A6.1,6.1,0,0,1,298.2,107.5Zm-.4-15a5.7,5.7,0,0,0-2.7.6L286.5,98c-.3.2-.8.6-.8,1.1s.5,1.1,1.3,1.6l7.5,4.3a6.5,6.5,0,0,0,6.2.2l8.6-4.9c.4-.2.9-.6.9-1.1s-.5-1.1-1.4-1.6l-7.5-4.3A9.5,9.5,0,0,0,297.8,92.5Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M295.8,106.2h-1.6v63.9h1.6Z" transform="translate(0 -0.8)" />
        <path class="cls-2" d="M308.7,104.1h-1.2v59.7h1.2Z" transform="translate(0 -0.8)" />
      </g>
      <g>
        <path
          class="cls-1"
          d="M315.7,167.9l-19,10.9,1,.6,18.8-10.9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M318,169.3l-18.9,10.9a1.9,1.9,0,0,0,1.1.4l18.2-10.4A1.5,1.5,0,0,0,318,169.3Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M305.8,190.9,324.7,180l-1-.5-18.8,10.9Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M308.2,192.4l19-10.9-1-.5-18.9,10.9Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M310.8,193.8l18.8-10.9-.8-.6-18.9,11Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M313.1,195.2l19-10.9-1-.5-18.9,10.9Z" transform="translate(0 -0.8)" />
        <path
          class="cls-1"
          d="M315.7,196.6l18.8-10.8-.8-.5-19,10.9Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M318.4,198l18.1-10.4a.8.8,0,0,0-.4-.7l-18.8,10.8Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M300.9,188l18.8-10.9a1.7,1.7,0,0,0-1.1-.4l-18.2,10.5A1.4,1.4,0,0,0,300.9,188Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M322.2,178.5l-.9-.5-18.9,10.9.9.5Z" transform="translate(0 -0.8)" />
        <path
          class="cls-2"
          d="M328.8,155.4h-25a.5.5,0,0,0-.5.5v25.4a2.7,2.7,0,0,0,1.7,2.2l7.5,4.3a7.3,7.3,0,0,0,7,.3l8.5-4.9a2.1,2.1,0,0,0,1.2-1.9V155.9C329.2,155.5,329,155.4,328.8,155.4Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M316.5,189.7a10.2,10.2,0,0,1-4.4-1.1l-7.5-4.3a4.8,4.8,0,0,1-1.9-2.1h-.1V156a1.2,1.2,0,0,1,1.2-1.2h25A1.2,1.2,0,0,1,330,156v26.3h-.1a4,4,0,0,1-1.5,1.9l-8.6,4.9A10.2,10.2,0,0,1,316.5,189.7ZM304,181.2c0,.6.5,1.1,1.4,1.6l7.4,4.3a6.7,6.7,0,0,0,6.3.2l8.6-4.9c.3-.2.8-.6.8-1.1v-.8h.1V156H304.2Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M328.8,155.4H317.3v33.4a6.5,6.5,0,0,0,2.3-.6l8.5-4.9a2.2,2.2,0,0,0,1.3-1.8V156Q329.1,155.4,328.8,155.4Z"
          transform="translate(0 -0.8)"
        />
        <path class="cls-1" d="M314.2,162.2h-1.6v26h1.6Z" transform="translate(0 -0.8)" />
        <path class="cls-2" d="M327,160.2h-1.2V182H327Z" transform="translate(0 -0.8)" />
        <path
          class="cls-3"
          d="M328,157.2l-8.5,4.9a8.2,8.2,0,0,1-7-.2l-7.5-4.3c-2.1-1.2-2.3-3.1-.5-4l8.6-4.9a8.2,8.2,0,0,1,7,.2l7.4,4.3C329.6,154.4,329.9,156.3,328,157.2Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M316.5,163.7a9,9,0,0,1-4.4-1.1l-7.5-4.3a3.4,3.4,0,0,1-2-2.9,3.1,3.1,0,0,1,1.6-2.5l8.5-4.8c2.1-1.3,5.5-1.1,7.9.2l7.4,4.3a3.4,3.4,0,0,1,2.1,2.9,3,3,0,0,1-1.6,2.5l-8.6,4.9A7.4,7.4,0,0,1,316.5,163.7Zm-.5-15a6.3,6.3,0,0,0-2.7.6l-8.5,4.9c-.4.2-.9.6-.9,1.1s.5,1.1,1.4,1.6l7.4,4.2c1.9,1.1,4.7,1.3,6.3.3l8.5-4.9c.4-.2.9-.6.9-1.1s-.5-1.1-1.4-1.6l-7.4-4.3A6.8,6.8,0,0,0,316,148.7Z"
          transform="translate(0 -0.8)"
        />
        <path
          class="cls-1"
          d="M323.4,141.9h-2.7a1.9,1.9,0,0,1-1.9-1.8v-2.7a1.9,1.9,0,0,1,1.9-1.8h2.7a1.8,1.8,0,0,1,1.8,1.8v2.7A1.9,1.9,0,0,1,323.4,141.9Zm-2.7-4.7-.3.2v2.7l.3.2h2.7a.2.2,0,0,0,.2-.2v-2.7a.2.2,0,0,0-.2-.2Z"
          transform="translate(0 -0.8)"
        />
      </g>
    </g>
    <g class="pie">
      <path
        class="cls-1"
        d="M252.6,82c.1-.4.4-.9.5-1.2L225.7,96.6a16.6,16.6,0,0,1,2.2-.3Z"
        transform="translate(0 -0.8)"
      />
      <path class="cls-1" d="M250.1,86l1.3-1.8L231.9,95.5l3.2-.8Z" transform="translate(0 -0.8)" />
      <path
        class="cls-1"
        d="M214.6,58.6l-2.4.3L188,72.9c-.1.4-.4.9-.5,1.4Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M219.7,58.4h-1.8L187.1,76.1c0,.4-.1.8-.1,1.1Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M224.1,58.5h-1.6L187.1,78.8c0,.4.2.6.2,1Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M228,59a5.8,5.8,0,0,1-1.4-.3l-39,22.6a3,3,0,0,1,.4.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M231.4,59.5a5,5,0,0,0-1.3-.3l-41.6,24a1.8,1.8,0,0,0,.5.8Z"
        transform="translate(0 -0.8)"
      />
      <path class="cls-1" d="M234.8,60.3l-1.3-.3L189.7,85.2l.6.7Z" transform="translate(0 -0.8)" />
      <path
        class="cls-1"
        d="M236.6,60.8,191.3,86.9l.6.6,45.8-26.4A4.5,4.5,0,0,1,236.6,60.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M240.5,62.4a1.9,1.9,0,0,1-1-.5L193.1,88.6l.8.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M243,63.5a3.1,3.1,0,0,1-1-.5L195.1,90.1l.9.5Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M245.3,65l-.9-.5-47,27a4.7,4.7,0,0,0,1,.5Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M247.2,66.5c-.2-.3-.5-.4-.7-.7l-46.6,27a1.6,1.6,0,0,1,.9.5Z"
        transform="translate(0 -0.8)"
      />
      <path class="cls-1" d="M249.1,68l-.6-.6L202.7,93.9l1.1.3Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M250.7,69.8l-.6-.8L205.5,94.7l1.2.4Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M251.9,71.7l-.5-.7L208.7,95.6l1.3.2Z" transform="translate(0 -0.8)" />
      <path
        class="cls-1"
        d="M252.9,73.8a2.5,2.5,0,0,1-.4-.9L212.2,96.2l1.5.2Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M253.4,76.2c0-.3-.2-.6-.2-.9L216.1,96.6h1.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M253.5,77.7l-32.9,19h1.8l31-17.9A3.7,3.7,0,0,0,253.5,77.7Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M208.2,59.7a29.9,29.9,0,0,0-3.2.9l-14.3,8.2-1.5,1.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-2"
        d="M243.3,54.8l-26.4-2.2L213,55.2a41,41,0,0,0-15.8,4.4l-4.1,2.9-4.7-.8v10c0,4.3,2.8,8.5,8.4,11.8,11.3,6.5,29.4,6.5,40.6.1a26.6,26.6,0,0,0,3.5-2.3V71.2L228.3,69l14.9-3.9Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M187.8,61.3l.6-.4.3.2,4.4.7a39.9,39.9,0,0,1,4-2.7A38.7,38.7,0,0,1,213,54.7l3.9-2.7h.2l27.1,2.3V65.4l-.5.2-12,3.1,10,1.8V81.4l-.2.2a18.3,18.3,0,0,1-3.6,2.6c-11.3,6.6-30,6.5-41.3-.1-5.5-3.2-8.6-7.4-8.7-11.9V61.3ZM217,53.5l-3.9,2.6a38.1,38.1,0,0,0-15.6,4.2,43.9,43.9,0,0,0-3.9,2.7l-.2.3H193l-3.9-.8v9.2c0,4.2,2.8,8.1,8.1,11.1,11,6.4,28.9,6.4,39.9,0a22.3,22.3,0,0,0,3-2V71.6l-12.6-2.2V68.3h.6l14.5-3.8V55.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-3"
        d="M217.2,61.7l26.1-6.9a21.3,21.3,0,0,0-8.3-6.1c-11.1-5.1-27.5-4.6-37.7,1s-11.8,17.1-.5,23.7,29.4,6.5,40.6.2a26.5,26.5,0,0,0,3.5-2.4l-23.7-9.5Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M189.7,55.4a21.5,21.5,0,0,1,7.2-6.3c10.4-5.8,27-6.3,38.5-1a21.9,21.9,0,0,1,8.5,6.4l.3.2v.7l-.4.2-24.1,6.2,22,8.7v.9l-.3.2a18.8,18.8,0,0,1-3.6,2.4c-11.4,6.7-30,6.5-41.4-.1-5.7-3.3-8.8-7.7-8.8-12.5A12.8,12.8,0,0,1,189.7,55.4Zm52.3-.9a24.9,24.9,0,0,0-7.4-5.2c-11-5-27-4.6-37.1,1-5.3,3.1-8.4,7-8.4,11.3s2.8,8.2,8.1,11.1c11,6.4,28.9,6.4,39.9.1a18.8,18.8,0,0,0,2.3-1.6l-23-9V61.1l.5-.2Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-3"
        d="M240.9,71l-23.7-9.3,8.1,15.9a33.4,33.4,0,0,0,12.1-4.2,12.8,12.8,0,0,0,3.5-2.4Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M216.3,61.6l.7-.8.5.3,24,9.4v.9l-.4.3-3.4,2.5a42,42,0,0,1-12.4,4.3H225Zm23.2,9.6L218.7,63l7.1,13.7a34.9,34.9,0,0,0,11.4-4Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M217.2,61.8h0V78.3a44.7,44.7,0,0,0,8.2-.7Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M235.5,74.5v9.9c1.6-.4,4-2.3,5.6-3.5l-.2-9.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M216.4,61.2l1.1-.3.2.5,8.6,16.8h-1a45.8,45.8,0,0,1-8.3.8h-.7Zm7.8,15.9-6.3-12.4V77.6A45.8,45.8,0,0,0,224.2,77.1Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-2"
        d="M217.1,78.3V61.8L211.4,78A55.9,55.9,0,0,0,217.1,78.3Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M216.8,61.1l1.2.2V79.2h-.8a37.7,37.7,0,0,1-5.8-.4h-.9Zm-.3,16.5V65.8l-4.1,11.6Z"
        transform="translate(0 -0.8)"
      />
      <path class="cls-1" d="M224.6,77.6v10H226v-10Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M193.6,71.5V81.6H195V71.5Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M196.8,73.9V84h1.5V73.9Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M236.4,56.7V66.8h1.5V56.7Z" transform="translate(0 -0.8)" />
      <path
        class="cls-1"
        d="M216.9,40.4a31.7,31.7,0,0,1,11.5,1.3l-.5,1.4A31.3,31.3,0,0,0,217,41.9Z"
        transform="translate(0 -0.8)"
      />
      <path class="cls-1" d="M230.3,42.5l-.5,1.3,4.1,1.6.5-1.3Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M204.6,31.9h-1.5v7.5h1.5Z" transform="translate(0 -0.8)" />
      <path class="cls-1" d="M207.5,35H200v1.6h7.5Z" transform="translate(0 -0.8)" />
    </g>
    <g id="deploy-btn">
      <path
        class="cls-1"
        d="M255.9,164.4a4.2,4.2,0,0,0-.1-2.5,3.8,3.8,0,0,0,.1-2.1,4.5,4.5,0,0,0,0-2,5,5,0,0,0,0-2.1,10.9,10.9,0,0,0,.1-1.8,7.6,7.6,0,0,0-.1-1.5,7.4,7.4,0,0,0,1.9-4.7c0-2.7-1.9-4.9-4.6-6.5L140.6,75.7c-5.7-3.5-15.5-3.1-22,.7l-70.9,41c-3.4,1.8-5.6,4.9-5.6,7.9a4.1,4.1,0,0,0,.1,1.1V143c.3,1.6,1.6,5.3,4.1,6.2h.3l.8.5L160,215.4c5.3,3,14.4,2.6,20.4-.8L251,174.1c3.7-2.2,5.5-5,4.9-7.6A5,5,0,0,0,255.9,164.4Zm-2.1-15.5a5.7,5.7,0,0,0-1.3-.8L139.9,82.5c-5.3-3.1-14.4-2.7-20.5.7L48.9,123.8a12.3,12.3,0,0,0-3.2,2.5,3,3,0,0,1-.2-1c0-1.9,1.5-3.8,4.1-5.3l70.6-40.6a19.9,19.9,0,0,1,10.6-2.6,15.6,15.6,0,0,1,7.9,1.9l112.6,65.6a4,4,0,0,1,2.7,3.4A5,5,0,0,1,253.8,148.9Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-3"
        d="M47.4,130.2,160,195.8c5.3,3.1,14.4,2.7,20.4-.7L251,154.5c6-3.4,6.8-8.7,1.5-11.7L139.9,77.2c-5.3-3.1-14.4-2.7-20.5.7L48.9,118.5C42.8,121.9,42.4,127.2,47.4,130.2Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M221,159.4l-1.9-3,14-8a.9.9,0,0,0,.4-.7,1.2,1.2,0,0,0-.4-.8l-12.9-7.6,1.9-3,12.9,7.6a4.3,4.3,0,0,1,0,7.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M83.8,136.7l-14.1-8a4,4,0,0,1-2.2-3.8,4.2,4.2,0,0,1,2.2-3.8l12.9-7.5,1.9,3-12.9,7.6a1.3,1.3,0,0,0-.3.7,1.5,1.5,0,0,0,.3.8l14.1,8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M117.5,96.5l-1.9-3L127,87c3-1.9,6.8-1.5,9.8,0l11,6.5-1.9,3-11-6.4a5.4,5.4,0,0,0-6,0Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M170.2,185.6a12.4,12.4,0,0,1-4.9-1.1L153.9,178l1.9-3,11.4,6.4a5.5,5.5,0,0,0,6,0l11-6.4,1.9,3-11,6.5A11,11,0,0,1,170.2,185.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M97.9,114.9l17.6-10.1,5.6,3.2a6.6,6.6,0,0,1,3.1,3.1,3.4,3.4,0,0,1,0,3.4,9.1,9.1,0,0,1-3.3,3.1l-.8.4a16,16,0,0,1-5.3,1.9,16.7,16.7,0,0,1-5.9.1,14.6,14.6,0,0,1-5.2-1.8Zm18.5-5.8-11,6.4,1.5.8a7.1,7.1,0,0,0,4.1.9,11.1,11.1,0,0,0,4.8-1.7l.8-.4c1.7-1,2.6-1.9,2.8-2.8s-.3-1.7-1.5-2.4Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M132.2,126.1l-6.6-3.8-4.2,2.4,7.8,4.5-3.2,1.9-12.1-7L131.4,114l12.2,7-3.3,1.9-7.9-4.6-3.7,2.2,6.7,3.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M137.9,131.1l-6,3.4-4.2-2.4L145.2,122l7.1,4a8.7,8.7,0,0,1,2.8,2.5,3,3,0,0,1,.3,2.6,5.6,5.6,0,0,1-2.3,2.3,10.5,10.5,0,0,1-5.9,1.3,14.5,14.5,0,0,1-6.6-2Zm3.3-1.9,2.7,1.6a4.7,4.7,0,0,0,2.5.7,4.1,4.1,0,0,0,2.4-.6,2.5,2.5,0,0,0,1.3-1.5c0-.5-.3-1-1.1-1.5l-2.8-1.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M151.3,141.9l7.3,4.3-3.2,1.9-11.6-6.7,17.5-10.2,4.3,2.5Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M179.7,152.4a18.4,18.4,0,0,1-5.5,2.1,18.9,18.9,0,0,1-5.8.2,15.5,15.5,0,0,1-5-1.7,7.6,7.6,0,0,1-3-2.9,3.5,3.5,0,0,1,.2-3.3,9.4,9.4,0,0,1,3.4-3.1l1-.6a18.4,18.4,0,0,1,5.5-2.1,18.9,18.9,0,0,1,5.8-.2,16.1,16.1,0,0,1,5.1,1.7,7.3,7.3,0,0,1,2.9,2.9,4.1,4.1,0,0,1-.3,3.4,9.9,9.9,0,0,1-3.5,3.1Zm-3.6-2.9c1.7-1,2.8-2,3.1-2.8s-.1-1.6-1.1-2.3-4.9-.9-8.2.9l-1.3.7a7.2,7.2,0,0,0-3.1,2.8c-.4.8,0,1.6,1.2,2.3a5.8,5.8,0,0,0,3.8.6,13,13,0,0,0,4.8-1.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M189.3,156.2l10.8-2.6,4.6,2.7-16.9,3.2-6.3,3.6-4.3-2.4,6.3-3.7,5.6-9.7,4.5,2.6Z"
        transform="translate(0 -0.8)"
      />
    </g>
    <g id="glove">
      <path
        class="cls-1"
        d="M222.9,177.2c2.3,7.5,3.3,14.6,13.5,16.9s14.6,2.1,12.3-5.9-3.9-13.7-12-14.3A23.6,23.6,0,0,0,222.9,177.2Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-4"
        d="M291.3,205.8h0a29.2,29.2,0,0,0,7.3-9.7,13.5,13.5,0,0,0,1.1-5.5,5.8,5.8,0,0,0-3.2-5.1l-3.1-1.9a6.5,6.5,0,0,1-3.1-4c-1.4-4.9-4.4-9.2-7.6-12.9h0a53.4,53.4,0,0,0-6.4-6.2h0a61.3,61.3,0,0,0-7.8-5.1l-1.1-.7-2.9-1.6h0a16.7,16.7,0,0,0-7.8-1.7,18.2,18.2,0,0,0-6.5,1.2c-6.2-.9-11.8.8-15,5.3a19.8,19.8,0,0,0-12.3,7.9l-1,.4a24.5,24.5,0,0,1-2.9.8,38.2,38.2,0,0,1-7.4.8l-1.9-.4-.6-.2-2.9-.7c-2.6-.5-5.9-.8-8.7.8a7.1,7.1,0,0,0-3.7,5.9,9.3,9.3,0,0,0,3.2,7,11.4,11.4,0,0,0,3,2.1h0c9.9,5.3,21.6,4,25.6,3.6h.1l1.5-.2h.8a10.5,10.5,0,0,1,2.5-.1,4.5,4.5,0,0,1,3.6,2.3,1.7,1.7,0,0,1-.7,1h0a3.5,3.5,0,0,1-1.7.9h-3.1a19.6,19.6,0,0,0-10.6,2.8c-5.9,3.3-9.2,8.8-8.5,13.3h0a6.8,6.8,0,0,0,4.4,5.3,6.4,6.4,0,0,0,2,.3l2.4-.2,3.8-.6,2-.4c4.2-.7,8.8-1.3,12.3-.4a10.6,10.6,0,0,0,4.4.1l5.4-.7h.6a119.8,119.8,0,0,1,16.4-1.6h1a9.4,9.4,0,0,1,3.2,1.1l1.8,1.1h0l1.9,1,.3.2a10,10,0,0,0,3.9,1.6h0a12.5,12.5,0,0,0,5.5-.7h0l1.2-.4,1.2-.5h.1A29.6,29.6,0,0,0,291.3,205.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M290.2,204.8c6.8-6.1,9.9-13.8,6.9-17.1s-10.9-1.1-17.7,5.1-9.9,13.8-6.9,17.1S283.4,211,290.2,204.8Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M282.7,209.9l-2.4.9a11.2,11.2,0,0,1-4.8.6,10.2,10.2,0,0,1-3.7-1.6l-3.7-2.1a11.6,11.6,0,0,0-3.7-1.3l-1.1-.2c-12.6.2-23.1,3.3-26.5,2.4-7.8-2-19.4,2.5-22.4,1.3a5.2,5.2,0,0,1-3.4-4.1c2.2,4.3,9.2,2.2,13.6.7a15.5,15.5,0,0,1,11.1,0c2.5,1.1,10.1,1.6,11-5,0,0,.9.7.7,3.5,0,0,6.3-2.9,12.4-2a40.3,40.3,0,0,1,12.4,4.2C273,207.5,279.2,208.4,282.7,209.9Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M223.8,166.9c4.3-1.4,8.5-1.4,10.1-.9,0,0-3.5-2.1-8.9-.4l-.4.3A5.8,5.8,0,0,0,223.8,166.9Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M236.1,159.1c4.3-1.4,5.5-1,7.1-.6,0,0-1.9-1.6-6-.7a.9.9,0,0,0-.5.3Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M250.4,153.9a12.2,12.2,0,0,1,5.7,1.6s-.9-1.3-4.1-1.9h-.6Z"
        transform="translate(0 -0.8)"
      />
      <path
        class="cls-1"
        d="M295.3,192.8c0,4.3-4.7,10.4-10.5,13.8s-10.5,2.5-10.5-1.7,4.7-10.4,10.5-13.8S295.3,188.5,295.3,192.8Z"
        transform="translate(0 -0.8)"
      />
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    deployButton() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-deploybutton",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
          defaults: {
            duration: 0.8,
          },
        })
        .add("deployB")
        .from(
          "#glove",
          {
            rotation: 30,
            transformOrigin: "100% 100%",
            ease: "sine",
          },
          "deployB"
        )
        .from(
          "#deploy-btn",
          {
            duration: 0.1,
            scale: 0.9,
            transformOrigin: "50% 50%",
            ease: "sine",
          },
          "deployB+=0.6"
        )
        .from(
          "#stacks g",
          {
            duration: 0.5,
            scaleY: 0,
            transformOrigin: "50% 100%",
            stagger: 0.1,
            ease: "sine",
          },
          "deployB+=0.6"
        )
        .from(
          ".pie",
          {
            duration: 1,
            scale: 0,
            rotation: 360,
            transformOrigin: "50% 50%",
            ease: "elastic.out(1, 0.5)",
          },
          "deployB+=0.6"
        );
    },
  },
  mounted() {
    this.deployButton();
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #0e1e25;
}

.cls-2,
.cls-4 {
  fill: #ffad43;
}

.cls-3 {
  fill: #fff;
}

.cls-4 {
  stroke: #0e1e25;
  stroke-width: 3px;
}
</style>
